module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog-confirm', {
    ref: "promoteVersionDialog",
    attrs: {
      "md-title": _vm.confirmPromote.title,
      "md-content-html": _vm.confirmPromote.content,
      "md-ok-text": _vm.confirmPromote.ok,
      "md-cancel-text": _vm.confirmPromote.cancel
    },
    on: {
      "close": _vm.promoteVersionConfirm
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "deleteVersionDialog",
    attrs: {
      "md-title": _vm.confirmDelete.title,
      "md-content-html": _vm.confirmDelete.content,
      "md-ok-text": _vm.confirmDelete.ok,
      "md-cancel-text": _vm.confirmDelete.cancel
    },
    on: {
      "close": _vm.deleteVersionConfirm
    }
  }), _vm._v(" "), _c('md-sidenav', {
    ref: "versionsNav",
    staticClass: "md-left"
  }, [_c('md-toolbar', {
    staticClass: "md-dense main-toolbar"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h3', {
    staticClass: "md-title"
  }, [_vm._v("History")])], 1), _vm._v(" "), (_vm.user.active_pay) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.saveVersion($event)
      }
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Version Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.versionTitle),
      callback: function($$v) {
        _vm.versionTitle = $$v
      },
      expression: "versionTitle"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("Save New Version")])], 1) : _vm._e(), _vm._v(" "), _c('md-list', {
    staticClass: "ql-version-list md-double-line"
  }, [_c('md-list-item', [_c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Current Version")]), _vm._v(" "), (!_vm.currentVersion) ? _c('span', [_vm._v("Live Edit")]) : _c('span', [_vm._v(_vm._s(_vm.currentVersion.name))])])]), _vm._v(" "), _c('md-list-item', [(!_vm.currentVersion) ? _c('md-icon', [_vm._v("label")]) : _c('md-icon', [_vm._v("label_outline")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [_c('span', [_vm._v("Live Version")])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        _vm.setActiveVersion(null)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1)], 1), _vm._v(" "), _c('md-list', _vm._l((_vm.days), function(filteredVersions, day) {
    return _c('md-list-item', {
      key: day,
      attrs: {
        "md-expand-multiple": ""
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(day))])]), _vm._v(" "), _c('md-list-expand', [_c('md-list', _vm._l((filteredVersions), function(version) {
      return _c('version-element', {
        key: version.id,
        attrs: {
          "project": _vm.project,
          "version": version
        },
        on: {
          "promoteVersion": _vm.promoteVersion,
          "deleteVersion": _vm.deleteVersion
        }
      })
    }))], 1)], 1)
  }))], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0286e63c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/history/versions-nav.vue
// module id = 634
// module chunks = 2